var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from '@/inversify.config';
import { EnvConfig } from '@/domains/base/types/env-config.interface';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
let FolderApiImpl = class FolderApiImpl {
    constructor(envConfig, psHttp) {
        this.envConfig = envConfig;
        this.psHttp = psHttp;
    }
    getFolderInitApi(spaceId, folderId) {
        return this.psHttp({
            url: `${this.envConfig.workspaceApiUrlPrefix}/permission/space/${spaceId}/folder/${folderId}`,
            method: 'GET',
            transformCode: true,
        }).then(({ data }) => {
            return _.get(data, 'data', {});
        });
    }
    getFolderSettingApi(params) {
        return this.psHttp({
            url: `${this.envConfig.workspaceApiUrlPrefix}/folder/setting`,
            method: 'GET',
            params,
            transformCode: true,
        }).then(({ data }) => {
            return _.get(data, 'data', {});
        });
    }
    async updateFolderAccessTimeApi(folderId) {
        await this.psHttp({
            url: `${this.envConfig.workspaceApiUrlPrefix}/folder/${folderId}/access`,
            method: 'POST',
            transformCode: true,
        });
    }
};
FolderApiImpl = __decorate([
    injectable(),
    __param(0, inject(EnvConfig)),
    __param(1, inject(PsHttp)),
    __metadata("design:paramtypes", [typeof (_a = typeof EnvConfig !== "undefined" && EnvConfig) === "function" ? _a : Object, typeof (_b = typeof PsHttp !== "undefined" && PsHttp) === "function" ? _b : Object])
], FolderApiImpl);
export { FolderApiImpl };
